module.exports = __webpack_public_path__ + "static/media/contact-agent.5c7957ee.svg";